import Animations from '../animations';

/**
 * M_BOV — Bouton overflow.
 *
 * Une page peut porter plusieurs blocs : chaque bouton ouvre la popin dont il
 * porte l'identifiant. Le module du flash info (pop-up.js) n'est pas réutilisé,
 * il ne gère qu'une popin et l'ouvre tout seul au chargement.
 */
export default class BoutonOverflow {
  static init() {
    document
      .querySelectorAll('[data-bouton-overflow-trigger]')
      .forEach((trigger) => new BoutonOverflow(trigger));
  }

  constructor(trigger) {
    this.trigger = trigger;
    this.popup = document.getElementById(
      trigger.getAttribute('data-bouton-overflow-trigger')
    );

    if (!this.popup || this.popup.dataset.boutonOverflowReady === 'true') {
      return;
    }

    this.dialog = this.popup.querySelector('.pop-up__dialog');
    this.overlay = this.popup.querySelector('.pop-up__overlay');
    this.closeButton = this.popup.querySelector('.pop-up__close');

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onClick = this.onClick.bind(this);

    this.trigger.addEventListener('click', this.open);
    this.closeButton?.addEventListener('click', this.close);
    this.popup.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKeydown);

    this.popup.dataset.boutonOverflowReady = 'true';
  }

  open() {
    this.popup.classList.add('is-open');
    this.popup.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    Animations.popup(this.popup);
    this.dialog?.focus();
  }

  close() {
    if (!this.popup.classList.contains('is-open')) {
      return;
    }

    this.popup.classList.remove('is-open');
    this.popup.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    // La popin est ouverte au clavier comme à la souris : le focus doit
    // revenir au bouton, sinon il repart en haut du document.
    this.trigger.focus();
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  onClick(event) {
    if (event.target === this.popup || event.target === this.overlay) {
      this.close();
    }
  }
}
